import React from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    InputAdornment,
    Stack,
    TextField,
    Typography,
} from "@mui/material";

const PUBLISH_OPTIONS = [
    { value: "EVS TV", label: "EVS TV" },
    { value: "Facebook", label: "Facebook" },
    { value: "Instagram", label: "Instagram" },
];

export default function PublicationPanel({
    duration,
    setDuration,
    publishTo,
    setPublishTo,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}) {
    const handleToggle = (value) => {
        setPublishTo((prev) =>
            prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
        );
    };

    return (
        <Stack spacing={1.5}>
            <TextField
                size="small"
                label="Temps d'affichage (en secondes)"
                type="number"
                value={duration}
                onChange={(e) =>
                    setDuration(e.target.value === "" ? "" : Math.max(0, Number(e.target.value)))
                }
                inputProps={{ min: 0, step: 1 }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">s</InputAdornment>,
                }}
                fullWidth
            />

            <Box>
                <Typography variant="caption" color="text.secondary">
                    Publier sur
                </Typography>
                <FormGroup>
                    {PUBLISH_OPTIONS.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={Array.isArray(publishTo) && publishTo.includes(value)}
                                    onChange={() => handleToggle(value)}
                                />
                            }
                            label={<Typography variant="body2">{label}</Typography>}
                        />
                    ))}
                </FormGroup>
            </Box>

            <TextField
                size="small"
                label="Date de début"
                type="date"
                value={startDate || ""}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
            />
            <TextField
                size="small"
                label="Date de fin"
                type="date"
                value={endDate || ""}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
            />
        </Stack>
    );
}
